<template>
    <v-container fluid fill-height>
        <Headful title="Bedankt!"></Headful>
        <Header
            color="white"
            show-logo
            :dark="true"
            show-back-button
            extended
        ></Header>
        <v-layout align-center class="mt-0 mb-5">
            <v-flex>
                <v-card class="elevation-0 mx-auto text-center" width="800">
                    <v-card-title></v-card-title>
                    <v-card-text class="pa-7">
                        <h1 class="text-h5 mb-5 text-center text--success">Afmelden</h1>
                        <p v-if="!isSignedOut">
                            Wilt u zich afmelden?<br />
                            Klik dan op de knop hieronder.
                        </p>
                        <v-btn v-if="!isSignedOut" color="primary" @click="signOut">Afmelden</v-btn>

                        <p v-if="isSignedOut">U bent afgemeld!</p>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Headful from "@/components/layout/Headful";
import Header from "@/components/layout/Header";
import apiClient from "@/api/apiClient";

export default {
    name: "ProfileRegisterSignOut",
    components: {
        Headful,
        Header,
    },
    data: () => ({
        isSignedOut: false,
    }),
    methods: {
        signOut() {
            // Archive profile
            apiClient.post('/profielen/'+this.$route.params.uuid+'/afmelden').then(() => {
                // Success
                this.isSignedOut = true;
            }).catch((e) => {
                console.error(e);
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Het is niet gelukt om u af te melden.' });
            });
        }
    },
}
</script>

<style scoped>

</style>
